import { getField } from "vuex-map-fields";
export default {
  getField,
  searchLink(state) {
    return `${window.location.origin}/${state.lang}/restaurants/search.html`;
  },
  favouritesSourceUrl(state) {
    let url = `/${state.lang}/favs.json?page=${state.favouritesPaginationPage}&details=true`;
    return url;
  },
  anyUpcomingReservations(state) {
    if (state.upcomingReservations.length >= state.windowData.totalUpcomingReservations) {
      return false
    }
    else {
      return true
    }
  },
  anyPastReservations(state) {
    if (state.pastReservations.length >= state.windowData.totalPastReservations) {
      return false
    }
    else {
      return true
    }
  },
  anyFavourites(state) {
    if (state.favourites.length >= state.windowData.totalFavourites) {
      return false
    }
    else {
      return true
    }
  },
  anyRewards(state) {
    if (state.rewards.length >= state.windowData.totalRewards) {
      return false
    }
    else {
      return true
    }
  }
}